export const TransportType = {
  TRUCK: 'TRUCK',
  FLIGHT: 'FLIGHT',
};
